export default [
  {
    path: '/expertInfo/expertView',
    component: () => import('@/epp/expertmain/expertInfo/ExpertView.vue'),
    meta: { title: '专家信息详情' },
    hidden: true
  },
  {
    path: '/expertInfo/expertEdit',
    component: () => import('@/epp/expertmain/expertInfo/ExpertEdit.vue'),
    meta: { title: '专家信息编辑' },
    hidden: true
  },
  {
    path: '/selectExpertApply/edit',
    component: () => import('@/epp/expertmain/selectexpertapply/SelectExpertApplyEdit'),
    meta: { title: '选取专家申请编辑' },
    hidden: true
  },
  {
    path: '/selectExpertApply/view',
    component: () => import('@/epp/expertmain/selectexpertapply/SelectExpertApplyView'),
    meta: { title: '选取专家申请详情' },
    hidden: true
  },
  {
    path: '/selectExpertApply/FeedbackForm',
    component: () => import('@/epp/expertmain/selectexpertapply/common/FeedbackForm'),
    meta: { title: '使用后情况' },
    hidden: true
  },
  {
    path: '/selectExpertApply/FeesForm',
    component: () => import('@/epp/expertmain/selectexpertapply/common/FeesForm'),
    meta: { title: '专家费用支付情况' },
    hidden: true
  },
  {
    path: '/selectExpertApply/expertFeesProjectList',
    component: () => import('@/epp/expertmain/expertFees/ExpertFeesProjectList.vue'),
    meta: { title: '相关项目列表' },
    hidden: true
  },
  {
    path: '/selectExpertApply/appoint/add',
    component: () => import('@/epp/expertmain/selectexpertapply/AppointExpertAdd'),
    meta: { title: '补录或指定专家申请' },
    hidden: true
  },
  {
    path: '/selectExpertApply/external/add',
    component: () => import('@/epp/expertmain/selectexpertapply/ExternalExpertAdd'),
    meta: { title: '库外专家申请' },
    hidden: true
  },
  {
    path: '/selectExpertApply/external/edit',
    component: () => import('@/epp/expertmain/selectexpertapply/ExternalExpertEdit'),
    meta: { title: '库外专家编辑' },
    hidden: true
  },

  {
    path: '/expertInfo/expertLoginEdit',
    component: () => import('@/epp/expertmain/expertInfo/ExpertLoginEdit.vue'),
    meta: { title: '专家信息编辑' },
    hidden: true
  },

  {
    path: '/expertInfo/expertLoginAdd',
    component: () => import('@/epp/expertmain/expertInfo/ExpertLoginAdd.vue'),
    meta: { title: '专家信息添加' },
    hidden: true
  },

  {
    path: '/expertInfo/expertLoginView',
    component: () => import('@/epp/expertmain/expertInfo/ExpertLoginView.vue'),
    meta: { title: '专家信息详情' },
    hidden: true
  },

  {
    path: '/expertInfo/expertLoginStockOutAdd',
    name: 'expertLoginStockOutAdd',
    component: () => import('@/epp/expertmain/expertInfo/ExpertLoginStockOutAdd.vue'),
    meta: { title: '专家出库申请' },
    hidden: true
  },

  {
    path: '/expertInfo/expertLeaveRecord',
    name: 'ExpertLeaveRecord',
    component: () => import('@/epp/expertmain/expertInfo/ExpertLeaveRecord.vue'),
    meta: { title: '专家休假' },
    hidden: true
  },

]
